import { gql } from '@apollo/client';

export const updateApplicantMutation = `
  updateApplicant(applicantId: $applicantId, payload: $payload) {
    id
  }
`;

export const UPDATE_APPLICANT = gql`
  mutation UpdateApplicant($applicantId: ID!, $payload: UpdateApplicantInput!) {
    ${updateApplicantMutation}
  }
`;
